export default "__VITE_ASSET__mXTymr3r2ElSlG4WWqrxow__";